module.exports = __webpack_public_path__ + "img/Withdraw-gold.c0729f28.svg";